module.exports = __webpack_public_path__ + "img/tatsuki.f524f644.jpg";